import React, { useState } from "react";

// import react slick
import Slider from "react-slick";
// import Image from "next/image";
import { FaStar } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimoni = ({
  listTestimoni = [
    {
      name: "Suresh A",
      city: "Dindigul",
      state: "Tamil Nadu",
      rating: "4.7",
      testimoni:
        "Excellent quality and lightweight. Perfect for home use and various tasks. This ladder is incredibly stable, making it safe to use. Highly recommend for anyone in need of a reliable ladder!",
    },
    {
      name: "Rajesh S",
      city: "Thirumangalm",
      state: "Tamil Nadu",
      rating: "4.5",
      testimoni:
        "Very durable and easy to handle. This ladder is a game-changer for my work. The build quality is exceptional, and it provides great value for money. Best ladder I've purchased so far!",
    },
    {
      name: "SaravaKumar M",
      city: "madurai",
      state: "Tamil Nadu",
      rating: "4.4",
      testimoni:
        "Perfect for both indoor and outdoor tasks, the ladder is incredibly stable and user-friendly. It exceeds all my expectations, making it an essential tool. Highly recommended!",
    },
    {
      name: "Kumaran R",
      city: "viruthunagar",
      state: "Tamil Nadu",
      rating: "4.5",
      testimoni:
        "Safe and dependable for any job, whether indoors or outdoors. Its stability and user-friendliness are remarkable. This ladder truly meets all my needs and is a must-have!",
    },
    {
        name: "Sobika A",
        city: "Madurai",
        state: "Tamil Nadu",
        rating: "4.6",
        testimoni:
          "Incredibly durable and simple to maneuver, this ladder has transformed my work. The outstanding build quality and excellent value make it the best ladder I've ever bought! be safe!",
      },
  ],
}) => {
  const settings = {
    dots: true,
    customPaging: function (i) {
      return (
        <a className="">
          <span className="mx-2 rounded-l-full rounded-r-full h-4 w-4 block cursor-pointer transition-all "></span>
        </a>
      );
    },
    dotsClass: "slick-dots w-max absolute mt-20  ",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [sliderRef, setSliderRef] = useState(null);

  return (
    <>
      <section className="my-10 container mx-auto" data-aos="fade-up" data-aos-duration="3000">
        <div  className="flex flex-col items-center justify-center mb-5 md:mb-10">

            <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 max-w-md text-[#182e55]">
            Trusted by Thousands of Happy Customer
            </h2>
            <p className="text-sm text-gray-600 tracking-wide leading-relaxed max-w-lg text-center">These are the stories of our customers who have joined us with great pleasure when using this crazy feature.</p>
        </div>
      <Slider
        {...settings}
        arrows={false}
        ref={setSliderRef}
        className="flex items-stretch justify-items-stretch"
      >
        {listTestimoni.map((listTestimonis, index) => (
          <div className="px-3 flex items-stretch" key={index}>
            <div className="border-2 border-gray-500 hover:border-[#142a4e] transition-all rounded-lg p-8 flex flex-col">
              <div className="flex flex-col xl:flex-row w-full items-stretch xl:items-center">
                <div className="flex order-2 xl:order-1">
                <FaUser className="w-9 h-9 text-[#142a4e] my-auto"/>
                  
                  <div className="flex flex-col ml-5 text-left">
                    <p className="text-lg text-black-600 capitalize">
                      {listTestimonis.name}
                    </p>
                    <p className="text-sm text-black-500 capitalize">
                      {listTestimonis.city},{listTestimonis.state}
                    </p>
                  </div>
                </div>
                <div className="flex flex-none items-center ml-auto order-1 xl:order-2">
                  <p className="text-sm">{listTestimonis.rating}</p>
                  <span className="flex ml-4">
                    <FaStar className="h-4 w-4 text-yellow-400" />
                  </span>
                </div>
              </div>
              <p className="mt-5 text-left">“{listTestimonis.testimoni}”.</p>
            </div>
          </div>
        ))}
      </Slider>
      <div className="flex w-full items-center justify-center">
        <div className="flex flex-none justify-between w-auto mt-8">
          <div
            className="mx-4 flex items-center justify-center h-12 w-12 rounded-full bg-white border-[#142a4e] border hover:bg-[#182e55] hover:text-white transition-all text-[#142a4e] cursor-pointer"
            onClick={sliderRef?.slickPrev}
          >
            <FaArrowLeft className="h-6 w-6 " />
          </div>
          <div
            className="flex items-center justify-center h-12 w-12 rounded-full bg-white border-[#142a4e] border hover:bg-[#182e55] hover:text-white transition-all text-[#142a4e] cursor-pointer"
            onClick={sliderRef?.slickNext}
          >
            <FaArrowRight className="h-6 w-6" />
          </div>
        </div>
      </div>
      </section>
    </>
  );
};

export default Testimoni;